<template>
  <div>
    <div class="navTab">
      <div class="cantain">
        <div class="navTab-contain flex-box">
          <div class="logo">
            <router-link to="/"
              ><img src="../../assets/logo.svg"
            /></router-link>
          </div>
          <ul class="list">
            <li
              v-for="(item, index) of nav"
              :key="index"
              :data-index="index"
              class="item"
              :class="item.active ? 'active' : ''"
            >
              <div class="item_name">
                <router-link :to="'/' + item.path">{{ item.name }}</router-link>
              </div>
              <div class="tab">
                <ul>
                  <li v-for="(citem, cindex) of item.children" :key="cindex">
                    <router-link :to="'/' + item.path + '/' + citem.path">{{
                      citem.name
                    }}</router-link>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
          <div class="search">
            <div class="search-btn"></div>
            <div class="search-input flex-box"> 
              <input
                type="text"
                v-model="searchValue"
                placeholder="请输入关键字"
              />
               <button @click="search"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      nav: [],
      searchValue: "",
      // showInput: false,
    };
  },
  computed: {
    ...mapGetters(["addRouters"]),
  },
  methods: {
    async getHeaderNav() {
      const result = await this.addRouters;
      this.nav = result;
      this.nav.map((item) => {
        item.active = false;
        if (item.id === this.$route.matched[1].meta.id) {
          item.active = true;
        }
      });
    },
    search() {
      console.log(this.searchValue)
    },
  },
  created() {
    this.getHeaderNav();
  },
  watch: {
    $route(to) {
      this.nav.map((item) => {
        item.active = false;
        if (item.id === to.matched[1].meta.id) {
          item.active = true;
        }
      });
      this.$forceUpdate();
    },
  },
};
</script>
<style lang="scss" scoped>
.navTab {
  color: #303030;
  font-size: 14px;
  background: #fff;

}
.navTab-contain {
  width: 1000px;
  margin: auto;
  position: relative;
  // justify-content: space-between;
}
.logo {
  width: 105px;
  height: 40px;
}
.list {
  display: flex;
  text-align: center;
  align-items: center;
  margin-right: 50px;

  .item {
    position: relative;
    height: 80px;
    line-height: 80px;
    min-width: 100px;
    .tab {
      a {
        color: #606060 !important;
      }
      display: none;
      position: absolute;
      background: #fff;
      top: 80px;
      left: 0;
      border-bottom: 10px solid $color-blue;
      z-index: 99;
      li {
        height: 50px;
        line-height: 50px;
        min-width: 100px;
        :hover {
          background: #e6eef6;
          color: $color-skyblue;
        }
      }
    }
  }
  :hover {
    .tab {
      display: block;
    }
    .item_name a {
      // color: $color-blue;
      background-color: #e6eef6;
    }
  }
}
.list li:nth-of-type(1) .item_name a{
  color: $color-blue ;
}

.cantain {
  width: 100%;
  // background: $color-blue;
}

.active {
  position: relative;
  background: #fff;
  a {
    color: $color-skyblue !important;
    font-size: 15px;
  }
  .tab a {
    color: #000;
  }
  &::before {
    content: "";
    width: 100%;
    height: 3px;
    position: absolute;
    bottom: 0;
    left: 0;
    background: $color-skyblue;
  }
}
.search {
  position: relative;
  height: 80px;
  display: table;
  
  .search-input {
    border: 2px solid $color-blue;
    display: none;
    position: absolute;
    top: 80px;
    left: -391px;
    z-index: 22;
    width: 430px;
    overflow: hidden;
    background-color: #fff;
    button {
      width: 50px;
      height: 50px;
      background: url("../../assets/icon/search.svg") no-repeat 50%/50%;
      border: 0;
      background-color: #e6eef6;

    }
    input {
      border: 1px solid #eeeeee;
      height: 50px;
      width: 380px;
      outline: none;
      padding: 0 10px;
      transition: 1s;
    }
  }
  .search-btn {
    height: 13px;
    width: 13px;
    background: url("../../assets/icon/search.svg") no-repeat 50%/50%;
    padding: 15px;
    border-radius: 50%;
    background-color: #fff;
    margin-top: 18px;

  }
  &:hover {
    .search-btn {
      background: url("../../assets/icon/Hsearch.svg") no-repeat 50%/50%;
      background-color: #fff;
      cursor: pointer;
    }
    .search-input {
      display: flex;
    }
  }
}
</style>